import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { hash } from 'rsvp';
import PeopleMergeController from 'cio/pods/people/merge/controller';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

export default class PeopleMerge extends Route {
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'Merge people',
      path: 'people.merge',
    };
  }

  model({
    primaryCustomerId,
    secondaryCustomerId,
  }: {
    primaryCustomerId: string | null;
    secondaryCustomerId: string | null;
  }) {
    return hash({
      primary: primaryCustomerId != null ? this.store.findRecord('customer', primaryCustomerId) : null,
      secondary: secondaryCustomerId != null ? this.store.findRecord('customer', secondaryCustomerId) : null,
    });
  }

  setupController(controller: PeopleMergeController, model: ReturnType<PeopleMerge['model']>, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setDefaults();
    controller.setCancelButtonParams();
  }

  resetController(controller: PeopleMergeController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.reset();
    }
  }
}
